import {
  styled,
  Typography,
} from '@mui/material';

export const StyledText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
}));